import Vue from 'vue'
export default {
    props: {
        globalapplications: {
            type: Array,
            default: function () {
                const vm = this
                const globalapplications = []
                if (!vm.isApplicationsLoaded) {
                    vm.$http.get('/api/Global/Applications').then((response) => {
                        globalapplications.push(...response.data.Data)
                        Vue.set(vm, 'isApplicationsLoaded', true)
                    })
                }
                return globalapplications
            }
        }
    },
    data(globalapplications) {
        return {
            isApplicationsLoaded: false
        }
    },
    methods: {
        currentapp(applicationid) {
            return this.globalapplications.find(a => a.ApplicationID == applicationid)
        }
    }
}